module.exports = __webpack_public_path__ + "img/23.232502b0.svg";